import { z } from "zod";

export const MemberFiltersSchema = z.object({
    memberIds: z.array(z.string()).optional(),
    segmentIds: z.array(z.uuid()).optional(),
    managerIds: z.array(z.uuid()).optional(),
    reportingLineIds: z.array(z.uuid()).optional(),
    departments: z.array(z.string()).optional(),
    jobTitles: z.array(z.string()).optional(),
    jobLevels: z.array(z.string()).optional(),
    genders: z.array(z.string()).optional(),
    workLocations: z.array(z.string()).optional(),
    hireDateMin: z.string().optional(),
    hireDateMax: z.string().optional(),
    isReportingManager: z.boolean().optional(),
    isDeactivated: z.boolean().optional()
});
export type MemberFilters = z.infer<typeof MemberFiltersSchema>;

const FilterIdSchema = z.uuid();

export function isFilterId(value: string) {
    return FilterIdSchema.safeParse(value).success;
}
